var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import "./table.styles.scss";
import { Helpers, _ } from "../../utils";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { InlineCheckbox } from "./inlineComponents/index";
import { SORT_TYPES } from "../../constants/enums";
import { Pagination } from "antd";
import "antd/dist/antd.css";
var uuidv4 = require("uuid/v4");
var defaultUUIDKey = "pndrUUID";
var addIcon = require("../../assets/images/addIcon.png");
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.addUUIDToData = function (data) {
            var transformedData = [];
            data.map(function (row) {
                var _a;
                transformedData.push(__assign({}, row, (_a = {}, _a[defaultUUIDKey] = uuidv4(), _a)));
            });
            return transformedData;
        };
        _this.getRowKeyAccessor = function (row) {
            var rowKeyAccessor = _this.props.rowKeyAccessor;
            var key = defaultUUIDKey;
            if (rowKeyAccessor) {
                key =
                    typeof rowKeyAccessor === "string"
                        ? rowKeyAccessor
                        : rowKeyAccessor(row);
            }
            return key;
        };
        _this.renderTableHeader = function () {
            var _a = _this.props, selectCheckboxPosition = _a.selectCheckboxPosition, selectable = _a.selectable, columns = _a.columns;
            var transformedColumns = columns;
            if (selectable && selectCheckboxPosition === "leftEnd") {
                transformedColumns = [{ header: "", accessor: "" }].concat(columns);
            }
            return (React.createElement("div", { className: "table-header-group", style: {
                    display: "grid",
                    gridTemplateColumns: _this.getColumnWidths(),
                } }, transformedColumns.map(function (column) {
                return _this.renderHeaderCell(column);
            })));
        };
        _this.renderHeaderCell = function (column) {
            if (column.sortable) {
                return (React.createElement("button", { className: "table-header button", onClick: function () { return _this.sortColumn(column); }, key: column.accessor },
                    column.header,
                    React.createElement("div", { className: "arrow-indicator" }, _this.renderArrowIndicator(column))));
            }
            return (React.createElement("div", { key: column.accessor, className: "table-header" }, column.header));
        };
        /**
         * React table now supports sorting (ascending, descending or none state),
         * for which the API exposes onSort function to the user to implement sorting as
         * they deem fit or on the basis of use case. Better than existing sorting policy which was
         * fidgety at times and didn't provide much flexibility.
         */
        _this.sortColumn = function (column) {
            var onSort = column.onSort;
            var _a = _this.state, sortBy = _a.sortBy, data = _a.data;
            if (onSort && (sortBy === SORT_TYPES.NONE || sortBy === SORT_TYPES.DESC)) {
                var sortedData = onSort(column, data, SORT_TYPES.ASC);
                _this.setState({
                    sortBy: SORT_TYPES.ASC,
                    sortedByAccessor: column.accessor,
                    data: sortedData,
                });
            }
            else if (onSort && sortBy === SORT_TYPES.ASC) {
                var sortedData = onSort(column, data, SORT_TYPES.DESC);
                _this.setState({
                    sortBy: SORT_TYPES.DESC,
                    sortedByAccessor: column.accessor,
                    data: sortedData,
                });
            }
        };
        // remove internal uuid before sending back data.
        _this.cleanOutputRowData = function (row) {
            var pndrUUID = row.pndrUUID, rest = __rest(row, ["pndrUUID"]);
            return rest;
        };
        _this.compareCleanObjects = function (obj1, obj2) {
            return _.isEqual(_this.cleanOutputRowData(obj1), _this.cleanOutputRowData(obj2));
        };
        _this.onSelectRows = function (row, event) {
            event && event.stopPropagation();
            var onRowSelect = _this.props.onRowSelect;
            var newSelectedRows = _this.state.selectedRows.slice();
            var key = _this.getRowKeyAccessor(row);
            var existingRowIndex = newSelectedRows.findIndex(function (selectedRow) {
                if (key === defaultUUIDKey) {
                    // if key is default, we need to compare clean objects because uuid might change with data change.
                    return _this.compareCleanObjects(selectedRow, row);
                }
                return selectedRow[key] === row[key];
            });
            if (existingRowIndex > -1) {
                newSelectedRows.splice(existingRowIndex, 1);
            }
            else {
                newSelectedRows.push(row);
            }
            _this.setState({ selectedRows: newSelectedRows });
            onRowSelect && onRowSelect(newSelectedRows, _this.cleanOutputRowData(row));
        };
        _this.renderArrowIndicator = function (column) {
            var _a = _this.state, sortedByAccessor = _a.sortedByAccessor, sortBy = _a.sortBy;
            if (sortedByAccessor === column.accessor) {
                if (sortBy === SORT_TYPES.ASC) {
                    return React.createElement("i", { className: "arrow up" });
                }
                else if (sortBy === SORT_TYPES.DESC) {
                    return React.createElement("i", { className: "arrow down" });
                }
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "arrow up" }),
                React.createElement("i", { className: "arrow down" })));
        };
        _this.renderTableBody = function () {
            var dragDropRows = _this.props.dragDropRows;
            return dragDropRows ? (React.createElement(Droppable, { droppableId: "react-table-body" }, function (provided) { return (React.createElement("div", { className: "table-body" },
                _this.renderDraggableTableRows(provided),
                provided && provided.placeholder)); })) : (React.createElement("div", { className: "table-body" }, _this.renderTableRows()));
        };
        _this.renderNoDataView = function () {
            return (React.createElement("div", { className: "table-row no-data-row" }, _.get(_this.props, "emptyDataText", "No Results")));
        };
        /**
         * tried to opt into virtual rendering but didn't get much performance bump,
         * instead a silly UI with two vertical scrolls in a single page.
         * Probably should work towards own version of virtual rendering of table rows.
         */
        _this.renderTableRows = function () {
            var _a = _this.props, onRowClick = _a.onRowClick, selectable = _a.selectable, isRowSelectable = _a.isRowSelectable, selectTarget = _a.selectTarget;
            var data = _this.state.data;
            return (React.createElement(React.Fragment, null, data.map(function (row, index) {
                var key = _this.getRowKey(row, index)("row");
                if (selectable &&
                    (isRowSelectable ? isRowSelectable(row, index) : true)) {
                    return (React.createElement("button", { key: key, onClick: function () {
                            return selectTarget === "checkbox"
                                ? onRowClick && onRowClick(row)
                                : _this.onSelectRows(row);
                        }, className: "row-container" }, _this.renderTableRowContent(row, index)));
                }
                else if (onRowClick) {
                    return (React.createElement("button", { onClick: function () { return onRowClick(row); }, key: key, className: "row-container" }, _this.renderTableRowContent(row, index)));
                }
                else {
                    return (React.createElement("div", { key: key, className: "row-container" }, _this.renderTableRowContent(row, index)));
                }
            })));
        };
        /**
         * so, draggable rows are different from normal rows, as they use react-beautiful-dnd,
         * in a render prop based pattern.
         */
        _this.renderDraggableTableRows = function (provided) {
            var onRowClick = _this.props.onRowClick;
            var data = _this.state.data;
            return (React.createElement("div", __assign({}, (provided && provided.droppableProps), { ref: provided && provided.innerRef }), data.map(function (row, index) {
                return (React.createElement(Draggable, { draggableId: "row-" + index, index: index }, function (provided) {
                    return onRowClick ? (React.createElement("a", __assign({ onClick: function () {
                            onRowClick && onRowClick(row);
                        } }, provided.draggableProps, provided.dragHandleProps, { ref: provided.innerRef }), _this.renderTableRowContent(row, index))) : (React.createElement("div", __assign({}, provided.draggableProps, provided.dragHandleProps, { ref: provided.innerRef }), _this.renderTableRowContent(row, index)));
                }));
            })));
        };
        _this.getIsRowSelected = function (row) {
            var selectedRows = _this.state.selectedRows;
            var key = _this.getRowKeyAccessor(row);
            var isRowSelected = selectedRows.filter(function (selectedRow) {
                if (key === defaultUUIDKey) {
                    return _this.compareCleanObjects(selectedRow, row);
                }
                return (selectedRow[key] = row[key]);
            }).length > 0;
            return isRowSelected;
        };
        _this.getColumnWidths = function () {
            var _a = _this.props, columnWidths = _a.columnWidths, selectable = _a.selectable, selectChecboxWidth = _a.selectChecboxWidth, selectCheckboxPosition = _a.selectCheckboxPosition;
            var isChecboxOnLeft = selectCheckboxPosition === "leftEnd";
            var selectableColWidths = isChecboxOnLeft
                ? (selectChecboxWidth || "5%") + " " + columnWidths
                : columnWidths + " " + (selectChecboxWidth || "5%");
            return selectable ? selectableColWidths : columnWidths;
        };
        _this.renderTableRowContent = function (row, index) {
            var _a = _this.props, addRows = _a.addRows, getRowStyleClass = _a.getRowStyleClass, getSelectedRowStyleClass = _a.getSelectedRowStyleClass;
            var data = _this.state.data;
            var isRowSelected = _this.getIsRowSelected(row);
            var selectedRowStyles = "";
            if (isRowSelected && getSelectedRowStyleClass) {
                selectedRowStyles = getSelectedRowStyleClass(row, index);
            }
            else if (isRowSelected) {
                selectedRowStyles = "react-table-selected-row";
            }
            var rowStyleClass = (getRowStyleClass && getRowStyleClass(row)) || "";
            /*
              To get different colour for alternative rows
              checking if the row index is divisible by 2 and changing colour accordingly
             */
            return (React.createElement("div", { className: index % 2
                    ? "table-row-colored " + rowStyleClass + " " + selectedRowStyles
                    : "table-row " + rowStyleClass + " " + selectedRowStyles },
                _this.renderRowComponents(_this.cleanOutputRowData(row), index),
                addRows && index === data.length - 1 && _this.renderAddRowButton()));
        };
        /**
         * accessing the key/key accessor function provided by user for more efficient rendering.
         */
        _this.getRowKey = function (row, index) {
            var rowKeyAccessor = _this.props.rowKeyAccessor;
            var key = "row-" + index;
            if (rowKeyAccessor) {
                key =
                    typeof rowKeyAccessor === "string"
                        ? _.get(row, rowKeyAccessor, key)
                        : rowKeyAccessor(row);
            }
            return function (prefix) {
                if (prefix === void 0) { prefix = ""; }
                return "" + prefix + key;
            };
        };
        _this.renderAddRowButton = function () {
            var onAddRow = _this.props.onAddRow;
            return (React.createElement("button", { className: "add-row-button", onClick: onAddRow },
                React.createElement("img", { src: addIcon, className: "add-icon", alt: "add-icon" })));
        };
        _this.renderRowComponents = function (row, rowIndex) {
            var _a = _this.props, columns = _a.columns, isRowSelectable = _a.isRowSelectable, renderRow = _a.renderRow, selectable = _a.selectable, selectCheckboxPosition = _a.selectCheckboxPosition;
            var rowKey = _this.getRowKey(row, rowIndex);
            var rowGroupKey = rowKey("row-group-" + rowIndex);
            var renderedRow = renderRow ? renderRow(row, rowIndex) : null;
            var isChecboxOnLeft = selectCheckboxPosition === "leftEnd";
            var isSelectable = selectable && (isRowSelectable ? isRowSelectable(row, rowIndex) : true);
            if (renderedRow) {
                return renderedRow;
            }
            return (React.createElement("div", { className: "overlay" },
                React.createElement("div", { className: "row-group", style: {
                        display: "grid",
                        gridTemplateColumns: _this.getColumnWidths(),
                    }, key: rowGroupKey },
                    isSelectable && isChecboxOnLeft && (React.createElement("div", { className: "react-table-row-select-checkbox" },
                        React.createElement(InlineCheckbox, { onChange: function (event) { return _this.onSelectRows(row, event); }, checked: _this.getIsRowSelected(row) }))),
                    columns.map(function (col, index) {
                        return col.Component ? (_this.renderProvidedComponent(col, row, rowIndex)) : (React.createElement("div", { className: "row-cell " + (col.getColStyleClass ? col.getColStyleClass(row) : ""), style: Helpers.isNonNullObject(row[col.accessor])
                                ? row[col.accessor].styles
                                : null, key: rowKey(col.accessor + "-row-cell-" + rowIndex) },
                            React.createElement("p", { className: "cell-content" }, _this.renderCell(col, row, rowIndex))));
                    }),
                    isSelectable && !isChecboxOnLeft && (React.createElement("div", { className: "react-table-row-select-checkbox" },
                        React.createElement(InlineCheckbox, { onChange: function (event) { return _this.onSelectRows(row, event); }, checked: _this.getIsRowSelected(row) }))))));
        };
        _this.renderCell = function (column, row, rowIndex) {
            var renderFallBack = _this.props.renderFallBack;
            var transformData = column.transformData;
            if (column.accessor &&
                Helpers.isNonNullObject(row[column.accessor]) &&
                Object.keys(row).length > 0 &&
                Object.keys(row).includes(column.accessor)) {
                return row[column.accessor].text;
            }
            if (column.accessor &&
                Object.keys(row).length > 0 &&
                Object.keys(row).includes(column.accessor)) {
                return transformData ? transformData(column, row) : row[column.accessor];
            }
            return (renderFallBack && renderFallBack(column, row, rowIndex)) || "-";
        };
        _this.renderProvidedComponent = function (col, row, index) {
            var Component = col.Component;
            return (React.createElement(Component, __assign({}, col.props, { row: row, index: index, key: "component-" + col.accessor + "-" + index })));
        };
        _this.renderTableComponent = function () {
            var data = _this.state.data;
            var _a = _this.props, pagination = _a.pagination, total = _a.total, onPageChange = _a.onPageChange, pageSize = _a.pageSize, currentPage = _a.currentPage, defaultCurrentPage = _a.defaultCurrentPage;
            var isDataEmpty = _.isEmpty(data);
            return pagination ? (React.createElement("div", { className: "paginated-react-table" },
                React.createElement("div", { className: "table-container" },
                    !isDataEmpty && _this.renderTableHeader(),
                    isDataEmpty ? _this.renderNoDataView() : _this.renderTableBody()),
                React.createElement(Pagination, { defaultCurrent: defaultCurrentPage ? defaultCurrentPage : undefined, total: total ? total : undefined, onChange: onPageChange ? onPageChange : undefined, pageSize: pageSize ? pageSize : undefined, current: currentPage ? currentPage : undefined }))) : (React.createElement("div", { className: "table-container" },
                !isDataEmpty && _this.renderTableHeader(),
                isDataEmpty ? _this.renderNoDataView() : _this.renderTableBody()));
        };
        _this.state = {
            data: _this.addUUIDToData(props.data),
            sortedByAccessor: "",
            sortBy: SORT_TYPES.NONE,
            selectedRows: props.selectedRows || [],
        };
        return _this;
    }
    Table.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, data = _a.data, selectedRows = _a.selectedRows;
        if (!_.isEqual(prevProps.data, data)) {
            this.setState({
                data: this.addUUIDToData(data),
            });
        }
        if (!_.isEqual(prevProps.selectedRows, selectedRows)) {
            this.setState({
                selectedRows: this.props.selectedRows || [],
            });
        }
    };
    Table.prototype.render = function () {
        var _a = this.props, dragDropRows = _a.dragDropRows, onDragEnd = _a.onDragEnd;
        return dragDropRows ? (React.createElement(DragDropContext, { onDragEnd: onDragEnd || Helpers.noop }, this.renderTableComponent())) : (this.renderTableComponent());
    };
    return Table;
}(React.Component));
export default Table;
//# sourceMappingURL=table.js.map